/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RevenueRecipient } from "../RevenueRecipient";

export class RevenueRecipient__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _targetPool: string,
    _assets: string[],
    _minOut: BigNumberish[],
    overrides?: Overrides
  ): Promise<RevenueRecipient> {
    return super.deploy(
      _nexus,
      _targetPool,
      _assets,
      _minOut,
      overrides || {}
    ) as Promise<RevenueRecipient>;
  }
  getDeployTransaction(
    _nexus: string,
    _targetPool: string,
    _assets: string[],
    _minOut: BigNumberish[],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nexus,
      _targetPool,
      _assets,
      _minOut,
      overrides || {}
    );
  }
  attach(address: string): RevenueRecipient {
    return super.attach(address) as RevenueRecipient;
  }
  connect(signer: Signer): RevenueRecipient__factory {
    return super.connect(signer) as RevenueRecipient__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RevenueRecipient {
    return new Contract(address, _abi, signerOrProvider) as RevenueRecipient;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_targetPool",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_minOut",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mAsset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    name: "RevenueReceived",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mAsset",
        type: "address",
      },
    ],
    name: "approveAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mBPT",
    outputs: [
      {
        internalType: "contract IConfigurableRightsPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "migrateBPT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minOut",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "notifyRedistributionAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
    ],
    name: "updateAmountOut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
